import { toast } from '../context/CustomToastContext';
import apiClient from "../network/apiClient";

class ApiProvider {


  async getCategory(input) {
    try {
      const response = await apiClient.get(`category/get`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getCourse(input) {
    try {
      const response = await apiClient.get(`course/get`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getCurriculam(input) {
    try {
      const response = await apiClient.get(`curriculam/get`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getReview(input) {
    try {
      const response = await apiClient.get(`review/get`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async register(input) {
    try {
      const response = await apiClient.post("users/register", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      }
    }
  }


  async login(input) {
    try {
      const response = await apiClient.post("users/login", input);
      console.log(response, "response");

      const message = response.data?.message ?? "Something went wrong";
      console.log(message, "message");

      if (response.status == 200 || response.status == 201 && response) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: response.data
        };
      }
    } catch (error) {
      return {
        status: false,
        response: error?.response?.data || error
      };
    }
  }

  async getCarouselCourse(input) {
    try {
      const response = await apiClient.get(`course/course-carousel?limit=` + input);
      const message = response.data?.message ?? "Something went wrong"
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getFacilitors(input) {
    try {
      const response = await apiClient.get("about-us/get-facilitors", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getFacilitorDetail(input) {
    try {
      const response = await apiClient.get(`about-us/get-facilitor-details/${input}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async addAddress(input) {
    try {
      const response = await apiClient.post("address", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      }
    }
  }


  async getAddress(userID, type) {
    try {
      const response = await apiClient.get(`address/${userID}`, {
        params: { type }
      });

      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }
  async getOrders(status, page = 0, limit = 10) {
    try {

      const response = await apiClient.get('orders', {
        params: {
          ...(status && status !== 'All' ? { orderStatus: status } : {}),
          page: page,
          limit: limit
        }
      });

      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }


  async getOrderCounts() {
    try {
      const response = await apiClient.get('order-counts');
      console.error("response :", response);

      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async orderDetails(id) {
    try {
      const response = await apiClient.get(`orders/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async updateAddress(UserAddressId, input) {
    try {
      const response = await apiClient.patch(`address/${UserAddressId}`, input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      }
    }
  }

  async updateProfile(userId, input) {
    try {
      const response = await apiClient.patch(`users/${userId}`, input);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      }
      return { status: false, response: response.data };
    } catch (error) {
      console.error("Error updating profile:", error);
      return { status: false, response: error };
    }
  }

  async deleteAddress(UserAddressId) {
    try {
      const response = await apiClient.delete(`address/${UserAddressId}`);

      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async emailverfiy(input) {
    try {
      const response = await apiClient.get(`users/verify/${input}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getManagementTeams(input) {
    try {
      const response = await apiClient.get("about-us/get-management-team", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getManagementTeamsDetail(input) {
    try {
      const response = await apiClient.get(`about-us/get-management-team-details/${input}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }


  async newsLetter(input) {
    try {
      const response = await apiClient.post("news-letter/add-newsletter", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        toast.success(message)
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        toast.error(message)
        // notification.showAlertNotification(message, false);/
        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      }
    }
  }

  async requestForgetPasswordOtp(input) {
    try {
      const response = await apiClient.post("users/forget-password", input);
      if (response.status == 200 || response.status == 201) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: response.data
        };
      }
    } catch (error) {
      return {
        status: false,
        response: error?.response?.data || error
      };
    }
  }

  async verifyForgetPasswordOtp(input) {
    try {
      const response = await apiClient.post("users/verify-forget-password-otp", input);
      if (response.status == 200 || response.status == 201) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: response.data
        };
      }
    } catch (error) {
      return {
        status: false,
        response: error?.response?.data || error
      };
    }
  }

  async resetPassword(input) {
    try {
      const response = await apiClient.post("users/reset-password", input);
      if (response.status == 200 || response.status == 201) {
        return {
          status: response.status,
          response: response.data
        };
      } else {
        return {
          status: false,
          response: response.data
        };
      }
    } catch (error) {
      return {
        status: false,
        response: error?.response?.data || error
      };
    }
  }

  async getCourseCalender(input) {
    try {
      const response = await apiClient.get(`course/calander-get`, {
        params: { date: input }
      });
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }
  async getPaymentMethod(input) {
    try {
      const response = await apiClient.get("payment/get-paymentmethods", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getCurrency(input) {
    try {
      const response = await apiClient.get("payment/get-currency", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async currencyList(input) {
    try {
      const response = await apiClient.get("currency", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async certificateView(input) {
    try {
      const response = await apiClient.post("course/certificate-view", input, {
        responseType: 'blob',
      });
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async updateUser(userId, input) {
    try {
      const response = await apiClient.put(`update-user/${userId}`, input);
      if (response.status == 200 || response.status == 201) {
        return { status: true, response: response.data };
      } else {
        return { status: false, response: response.data };
      }
    } catch (error) {
      return {
        status: false,
        response: error.response?.data || "Something went wrong"
      };
    }
  }

  async getUser(userId) {
    try {
      const response = await apiClient.get(`user/${userId}`);
      if (response.status == 200 || response.status == 201) {
        return { status: true, response: response.data };
      } else {
        return { status: false, response: response.data };
      }
    } catch (error) {
      return {
        status: false,
        response: error.response?.data || "Something went wrong"
      };
    }
  }

  async updateOrderStatus(input) {
    try {
      const response = await apiClient.put(`orders/update-status`, input);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      } else {
        return { status: false, response: response.data };
      }
    } catch (error) {
      console.error("Error in updateOrderStatus:", error);
      return { status: false, response: error?.response?.data || error };
    }
  }


  async createReturnOrder(input) {
    try {
      const response = await apiClient.post(`return-orders`, input);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      } else {
        return { status: false, response: response.data };
      }
    } catch (error) {
      console.error("Error in createReturnOrder:", error);
      return { status: false, response: error?.response?.data || error };
    }
  }

  async getReturnOrders(userId, page = 0, limit = 10) {
    try {
      const response = await apiClient.get(`return-orders`, {
        params: {
          page: page,
          limit: limit,
          type: 'User',
          userId: userId
        }
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      } else {
        return { status: false, response: response.data };
      }
    } catch (error) {
      console.error("Error in getReturnOrders:", error);
      return { status: false, response: error?.response?.data || error };
    }
  }

  async currencyList() {
    try {
      const response = await apiClient.get('/currency');
      return { status: true, response: response.data };
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  }

  async updateCartCurrency(data) {
    try {
      const response = await apiClient.patch('/cart-detail/update-currency', data);
      return { status: true, response: response.data };
    } catch (error) {
      return { status: false, response: error?.response?.data || error };
    }
  }

}

const apiProvider = new ApiProvider()
export default apiProvider